import process from "node:process";
import { writable } from "svelte/store";
import { err, ok, type Result } from "./result.ts";

const API_PATH = "/api";
const DEFAULT_DV_BASE_URL: string = "http://localhost:8080" + API_PATH;
const STORAGE_KEY = `${process.env.PROJECT}-target_url`;

export function parseUrl(s?: string | null): Result<string, string> {
  try {
    if (s) {
      return ok(new URL(s).href);
    } else {
      return err("empty url string");
    }
  } catch (error) {
    return err(`invalid url: ${error}`);
  }
}

export function loadBaseUrlFromStore(prodUrlFullPath: string): string {
  const stored = globalThis.localStorage.getItem(STORAGE_KEY);

  if (!stored) {
    const res = getProdBaseUrl(prodUrlFullPath);
    globalThis.localStorage.setItem(STORAGE_KEY, res);
    return res;
  }

  const parsed = parseUrl(stored);
  if (parsed.isOk()) {
    return parsed.value;
  } else {
    return DEFAULT_DV_BASE_URL;
  }
}

export function getProdBaseUrl(prodUrlFullPath: string): string {
  if (
    globalThis.location.host.startsWith("localhost") ||
    globalThis.location.host.startsWith("192.168")
  ) {
    return prodUrlFullPath;
  } else {
    return globalThis.location.origin + API_PATH;
  }
}

export function storeBaseUrlInStore(baseUrl: string): Result<string, string> {
  const parsed = parseUrl(baseUrl);
  if (parsed.isOk()) {
    globalThis.localStorage.setItem(STORAGE_KEY, parsed.value);
  } else {
    if (import.meta.env.DEV) console.log(`invalid baseUrl: ${parsed.error}`);
  }
  return parsed;
}

export function setupTargetUrlStore(prodUrl: string) {
  const baseUrl = loadBaseUrlFromStore(prodUrl + API_PATH);
  const { subscribe, set } = writable<string>(baseUrl);

  return {
    subscribe,
    setUrl: (s: string) => {
      const res = storeBaseUrlInStore(s);
      if (res.isOk()) {
        set(res.value);
      } else {
        if (import.meta.env.DEV) console.log(`invalid targetUrl: ${res.error}`);
      }
    },
  };
}
